var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 45,
    viewBox: "0 0 41 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_771)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86201 43.9578C4.58884 43.9556 3.36843 43.4548 2.46816 42.5653C1.56789 41.6757 1.06117 40.4698 1.05893 39.2117V5.79236C1.05628 4.95875 1.27641 4.13925 1.69716 3.41671C2.1179 2.69418 2.72428 2.09424 3.45497 1.67759C4.18566 1.26095 5.01478 1.04237 5.8584 1.04395C6.70202 1.04554 7.53026 1.26722 8.25934 1.68661L37.548 18.3984C38.2772 18.8141 38.8828 19.4122 39.3038 20.1326C39.7249 20.853 39.9466 21.6702 39.9466 22.502C39.9466 23.3339 39.7249 24.1511 39.3038 24.8715C38.8828 25.5918 38.2772 26.19 37.548 26.6057L8.25934 43.3175C7.53195 43.7338 6.70686 43.9546 5.86625 43.9578H5.86201Z",
    fill: "#AA1070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07591 39C7.9955 38.9983 6.95986 38.6132 6.19589 37.9292C5.43192 37.2451 5.00192 36.3178 5.00002 35.3503V9.65144C4.99777 9.01042 5.18458 8.38023 5.54162 7.82462C5.89866 7.269 6.41323 6.80766 7.03329 6.48726C7.65336 6.16687 8.35694 5.99879 9.07284 6.00001C9.78873 6.00122 10.4916 6.1717 11.1103 6.4942L35.9646 19.3453C36.5834 19.6649 37.0973 20.1249 37.4546 20.6788C37.8119 21.2328 38 21.8612 38 22.5009C38 23.1406 37.8119 23.769 37.4546 24.3229C37.0973 24.8769 36.5834 25.3368 35.9646 25.6565L11.1103 38.5076C10.493 38.8278 9.79284 38.9975 9.07951 39H9.07591Z",
    fill: "#CD3F97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86185 2.09263C6.51702 2.09471 7.15998 2.26796 7.7255 2.59485L37.0142 19.2941C37.5824 19.6185 38.0541 20.085 38.3821 20.6467C38.7101 21.2083 38.8828 21.8453 38.8828 22.4937C38.8828 23.1421 38.7101 23.7792 38.3821 24.3408C38.0541 24.9024 37.5824 25.3689 37.0142 25.6933L7.7255 42.4009C7.15786 42.7287 6.51258 42.9023 5.85513 42.9041C5.19768 42.9059 4.55142 42.7358 3.98197 42.4111C3.41252 42.0864 2.94014 41.6187 2.61271 41.0553C2.28528 40.492 2.11449 39.853 2.11765 39.2034V5.7924C2.11765 4.81115 2.5121 3.87011 3.21428 3.17627C3.91645 2.48243 4.86882 2.09263 5.86185 2.09263ZM5.86185 0C4.30784 0.00221423 2.81813 0.61318 1.71928 1.69899C0.620426 2.7848 0.00212236 4.25683 -0.000118462 5.7924V39.2118C-0.00550447 40.2298 0.261491 41.2312 0.77388 42.1144C1.28627 42.9976 2.02584 43.7313 2.9176 44.2411C3.80937 44.751 4.82165 45.0189 5.85192 45.0176C6.8822 45.0164 7.89387 44.7461 8.78438 44.2341L38.0731 27.5265C38.9632 27.0183 39.7022 26.2877 40.2161 25.408C40.7299 24.5282 41.0004 23.5304 41.0004 22.5146C41.0004 21.4989 40.7299 20.501 40.2161 19.6213C39.7022 18.7416 38.9632 18.0109 38.0731 17.5028L8.78438 0.795186C7.89646 0.285719 6.8886 0.0158226 5.86185 0.0125425V0Z",
    fill: "#F8EBFD"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 8.00006C12.5 9.00006 15 10.7591 16.6404 11.6781C19 13.0001 21.8137 14.6926 23.5 14.5001C25.7693 13.8707 21.5877 12.6277 20 11.5001C18.0691 10.0961 15.9137 8.69938 13.5 8.00007C11.5 6.50008 8.24785 5.75936 10.5 8.00006Z",
    fill: "url(#paint0_radial_0_771)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_771",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.17561 32.7474) rotate(69.595) scale(62.4708 72.8156)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.1a57c5e4a47ceed336ad312adcbed76d.svg";
export { ForwardRef as ReactComponent };